<template>
  <div class="container">
    <div class="search-container">
      <input type="text" v-model="searchInput" @input="clubSearch" />
    </div>

    <div class="box-container">
      <table>
        <tr>
          <th
            style="cursor: pointer"
            @click="order == 'asc' ? order = 'desc' : order = 'asc'"
          >Name {{order == 'asc' ? '&#9650;' : '&#9660;' }}</th>
        </tr>

        <tr v-for="(club, index) in clubs" :key="index">
          <td>
            <a @click="$router.push(`/clubs/${club.id}`)">{{club.name}}</a>
          </td>
        </tr>
      </table>

      <div class="btn-container">
        <button class="loadmore" @click="loadMore">Load More</button>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../db";

export default {
  data() {
    return {
      baseQuery: db.collection("clubTeams").limit(30),
      currentQuery: null,
      clubs: [],
      order: "asc",
      searchInput: ""
    };
  },
  created() {
    this.executeQuery();
  },
  methods: {
    queryBuilder() {
      this.currentQuery = this.baseQuery.orderBy("searchName", this.order);

      if (this.searchInput !== "" && this.searchInput !== null) {
        const start = this.searchInput.toLowerCase();
        const end = start + "\uf8ff";

        this.order == "asc"
          ? (this.currentQuery = this.currentQuery.startAt(start).endAt(end))
          : (this.currentQuery = this.currentQuery.startAt(end).endAt(start));
      }
    },
    executeQuery() {
      this.queryBuilder();
      this.currentQuery.get().then(snap => {
        this.clubs = snap.docs.map(doc => {
          return {
            ...doc.data(),
            id: doc.id
          };
        });
        this.last = snap.docs[snap.docs.length - 1];
      });
    },
    loadMore() {
      if (this.last) {
        this.currentQuery
          .startAfter(this.last)
          .get()
          .then(snap => {
            if (snap.empty) {
              alert("no more items to load");
            } else {
              this.last = snap.docs[snap.docs.length - 1];
              const moreClubs = snap.docs.map(doc => {
                return {
                  ...doc.data(),
                  id: doc.id
                };
              });

              this.clubs = [...this.clubs, ...moreClubs];
            }
          });
      }
    },
    clubSearch() {
      this.executeQuery();
    }
  },
  watch: {
    order() {
      this.executeQuery();
    }
  }
};
</script>

<style lang="scss" scoped>
tr th,
tr td {
  padding-left: 70px;
}
</style>